/**
 * `/subscription` — the current entitlement.
 *
 * One `RouteObject`, so the file is singular. The folder is `status/` rather
 * than `index/`: the URL is `/subscription`, the mockup file is
 * `subscription/index.html`, and naming the folder after the file would give
 * the area an `index/` that means «the subscription status page» — which reads
 * as a barrel rather than as a surface. The route map in this repo's PRD-TDD
 * names `features/subscription/status/`, and that is what is followed here.
 *
 * No `loader`: the page owns its reads, including the `PENDING` poll, which a
 * loader could not express without a second cache.
 */
import type { RouteObject } from 'react-router-dom';

export const subscriptionStatusRoute: RouteObject = {
  path: 'subscription',
  lazy: async () => {
    const { StatusPage } = await import('./Status');
    return { Component: StatusPage };
  },
};
